<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="4">
            <h3>صفحة الاستمارات</h3>
          </v-col>

          <v-col cols="4" align="center">
            <h3>عدد الاستمارات اليومي : {{ formApplicationCounter }} استمارة</h3>
          </v-col>

          <v-col cols="4" align="left">
            <v-btn class="mx-2" fab small color="primary" @click="initialData">
              <v-icon dark> mdi-sync </v-icon>
            </v-btn>
            <AddForm style="display: inline-block" :formApplications="formApplication" @reloadTask="initialData" v-if="!overlay" />
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-container class="container" fluid>
      <v-card elevation="6">
        <v-card-title>
          <v-text-field v-model="search" @keyup.enter="searchFormApplication" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="formApplication" :items-per-page="15" item-key="idStudent" class="table-content">
          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>

          <template v-slot:[`item.level`]="{ item }">
            <p style="padding: 0 3px">{{ item.level | setLevel }}</p>
          </template>

          <template v-slot:[`item.studyType`]="{ item }">
            <p style="padding: 0 3px">{{ item.studyType | setStudyType }}</p>
          </template>

          <template v-slot:[`item.amount`]="{ item }">
            <p style="padding: 0 3px">
              {{
                item.amount.toLocaleString("en-US")
              }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <EditForm :formApplication="item" style="display: inline-block" @reloadTask="initialData()" />

            <DeleteDialog :dataToDelete="item" :url="`${$store.state.apiUrlFees}/formApplication/${item.idFormApplication}`" style="display: inline-block" @reloadTask="initialData()" />
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AddForm from "./../components/AddForm.vue";
import EditForm from "./../components/EditForm.vue";
import DeleteDialog from "./../components/DeleteDialog.vue";
export default {
  components: {
    AddForm,
    EditForm,
    DeleteDialog,
  },
  data: () => ({
    search: "",
    formApplicationCounter: 0,
    overlay: false,
    selected: [],
    formApplication: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "رقم الاستمارة", value: "formNumber" },
      { text: "تاريخ الاستمارة", value: "applicationDateFormat" },
      { text: "المبلغ", value: "amount" },
      { text: "الاجراءات", value: "actions" },
    ],
  }),
  created() {
    this.initialData();
  },
  methods: {
    searchFormApplication() {
      let self = this;

      self.$http
        .get(`${self.$store.state.apiUrlFees}/searchByNumber/${self.search}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res.data);
          self.formApplication = [res.data];
        })
        .catch((e) => {
          this.$toasted.error("هذه الاستمارة غير موجودة");
        });
    },
    initialData() {
      let self = this;
      self.overlay = true;
      if (self.$store.state.userData.roleId == 61) {
        self.$http
          .get(`${self.$store.state.apiUrlFees}/formApplicationsToday`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          })
          .then((res) => {
            console.log(res.data);
            self.formApplication = res.data.filter((form) => form.createdBy == self.$store.state.userData.idEmployee);
            self.overlay = false;
          })
          .catch((e) => {
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
      } else {
        self.$http
          .all([
            self.$http.get(`${self.$store.state.apiUrlFees}/formApplicationsToday`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
            self.$http.get(`${self.$store.state.apiUrlFees}/formApplicationsByYearId/76`, {
              headers: { Authorization: `Bearer ${self.$store.state.user}` },
            }),
          ])
          .then(
            self.$http.spread((todayApplication, allApplications) => {
              self.formApplication = allApplications.data;
              self.formApplicationCounter = todayApplication.data.length;
              self.overlay = false;
            })
          )
          .catch((err) => {
            console.log(err);
            self.overlay = false;
            this.$toasted.error("حدث خطأ الرجاء التأكد من الاتصال بالانترنت");
          });
      }
    },
    selectStudent(student) {
      console.log(student);
    },
  },
  filters: {
    setLevel: function (level) {
      if (level == 1) {
        return "المرحلة الاولى";
      } else if (level == 2) {
        return "المرحلة الثانية";
      } else if (level == 3) {
        return "المرحلة الثالثة";
      } else if (level == 4) {
        return "المرحلة الرابعة";
      } else if (level == 5) {
        return "المرحلة الخامسة";
      }
    },
    setStudyType: function (studyType) {
      if (studyType == 1) {
        return "صباحي";
      } else {
        return "مسائي";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
